import { GEODE_FRAME } from './constants';

export type GeodeDef = {
  path: string;
  crackSheet: string;
  frames: number;
  tapsPerFrame: number;
  frameWidth: number;
  breakSheet: string;
  breakFrames: number;
  breakDur: number;
  jsonPath: string;
};

export const GEODE_DEFS: Record<string, GeodeDef> = {
  'Dust Geode': {
    path: 'Geodes/Dust Geode/',
    crackSheet: 'crack-sheet.png',
    frames: 7,
    tapsPerFrame: 7,
    frameWidth: GEODE_FRAME,
    breakSheet: 'Dust_geode_open.png',
    breakFrames: 27,
    breakDur: 0.81,
    jsonPath: 'Dust_geode_open.json',
  },
};

export function getGeodeMaxHp(geodeType: string) {
  const def = GEODE_DEFS[geodeType];
  if (!def) return 49;
  return def.frames * def.tapsPerFrame;
}

export function hpToVisual(hp: number, geodeType: string) {
  const def = GEODE_DEFS[geodeType];
  if (!def) return { frame: 1, tapCount: 0 };
  const maxHp = getGeodeMaxHp(geodeType);
  const damageDealt = Math.min(maxHp, Math.max(0, maxHp - hp));
  const frame = Math.min(def.frames, Math.floor(damageDealt / def.tapsPerFrame) + 1);
  const tapCount = damageDealt % def.tapsPerFrame;
  return { frame, tapCount };
}

export function geodeCrackSheetKey(geodeKey: string) {
  return `geode-crack-${geodeKey.replace(/[^a-z0-9]+/gi, '_')}`;
}

export function geodeCrackFrameIndex(frame: number) {
  return Math.max(0, frame - 1);
}
